'use client';

import { useRoomContext } from '@livekit/components-react';
import { useRecordingRealtimeSync } from '@/lib/useRecordingRealtimeSync';

/** Escuta eventos de gravação do servidor (data channel) e faz poll de fallback. */
export function RecordingRealtimeListener() {
  const room = useRoomContext();
  useRecordingRealtimeSync(room);
  return null;
}
